import Vue from 'vue'
import VueRouter from 'vue-router'
import Analyse from '../views/Analyse.vue'
import Home from '../views/Home.vue'
import Demo from '../views/Demo.vue'
import Questionnaire from '../views/Questionnaire.vue'

Vue.use(VueRouter)

const routes = [
  {path: '/', name: 'home', component: Home},
  {path: '/analyse', name: 'analyse', component: Analyse},
  {path: '/demo', name: 'demo', component: Demo},
  {path: '/questionnaire', name: 'questionnaire', component: Questionnaire},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
